import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import InvestorInvestmentSummaryEndpoints from "../../../endpoints/InvestmentSummary/investor";
import { GroupedInvestmentModel } from "../../../models";
import { JsonApiSingleResponse, ModelScope } from "../../../types";
import { ModelId } from "../../../../defines";

export function apiInvestmentsSummaryModel(
  opts: ApiModelOptions<GroupedInvestmentModel>,
) {
  const model = ApiModel<GroupedInvestmentModel>("grouped-investments", {
    urls: {
      [ModelScope.Investor]: InvestorInvestmentSummaryEndpoints,
    },
    ...opts,
  });

  const getSummaryByManagerId = async (managerId?: ModelId) => {
    return await opts.apiClient.apiRequest<
      JsonApiSingleResponse<GroupedInvestmentModel>
    >(InvestorInvestmentSummaryEndpoints.getMany, "GET", {
      manager_id: managerId,
    });
  };

  const getSummary = async () => {
    return await opts.apiClient.apiRequest<
      JsonApiSingleResponse<GroupedInvestmentModel>
    >(InvestorInvestmentSummaryEndpoints.getMany, "GET");
  };

  return {
    ...model,
    getSummary,
    getSummaryByManagerId,
  };
}

export default apiInvestmentsSummaryModel;
